module.exports = __webpack_public_path__ + "static/media/forklift.b0c978c7.svg";